import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import NewOrderProductCard from "./NewOrderProductCard";

const NewOrderTable = ({
  productLibrary,
  setMissingDetailsData,
  vendorFilter,
  searchContent,
  openCreateProductModal,
}) => {
  // a search that matched nothing is the moment the user most likely wants to create the product, so
  // offer it right here instead of making them go find the product library
  if (productLibrary?.length === 0 && searchContent) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          padding: 6,
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          &quot;{searchContent}&quot; not found
        </Typography>
        <Button
          variant="contained"
          sx={{ marginTop: 4 }}
          onClick={() => openCreateProductModal(searchContent)}
        >
          <AddOutlinedIcon />
          <Typography variant="largeButton">Add Product</Typography>
        </Button>
      </Box>
    );
  }

  return (
    <Grid container spacing={2} direction="row" sx={{ minWidth: "100%" }}>
      {productLibrary?.map((x) => (
        <NewOrderProductCard
          key={x.id}
          product={x}
          setMissingDetailsData={setMissingDetailsData}
          vendorFilter={vendorFilter}
        />
      ))}
    </Grid>
  );
};

export default NewOrderTable;
